import React from 'react'
import Stepper from '../shared/stepper.js'
import ModalError from '../shared/modal_errore.js'
import CTA from '../shared/cta.js'
import moment from 'moment';
import 'moment/locale/it';
import Spinner from "../shared/spinner.js";
import RecapArea from "../shared/recap_area.js";
import utils from '../../modules/utils.js'
import apiInvoker from "../../modules/apiInvoker";
import { setGiorno, setConsensi } from "../../actions/index";
import { clearDisponibilita, clearHistoryBack, setProdotto, setFiliale, setOrario } from "../../actions/index";
import { connect } from 'react-redux';
import { trackPageView, stopDigitalAssistant } from "../../modules/datalayer.js"
import './data_appuntamento.css';
/* Flow */
import { handleFlow, goToContactCenter } from '../../flow/flow';

const mapDispatchToProps = dispatch => {
  return {
    setGiorno: (giorno) => dispatch(setGiorno(giorno)),
    setConsensi: (giorno) => dispatch(setConsensi(giorno)),
    clearDisponibilita: (d) => dispatch(clearDisponibilita(d)),
    clearHistoryBack: (c) => dispatch(clearHistoryBack(c)),
    setProdotto: (p) => dispatch(setProdotto(p)),
    setFiliale: (f) => dispatch(setFiliale(f)),
    setOrario: (o) => dispatch(setOrario(o)),
  }
}

const mapStateToProps = state => {
  return {
    prodotto: state.prodotto,
    filiali: state.dati_locali.filiali,
    telefonico_forzato: state.telefonico_forzato,
    modificando: state.modificando,
    flussoModifica: state.flusso_modifica,
  };
};

class DataAppuntamento extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      giorni: [],
      giorni_caricati: false,
      pagina_giorni: 0
    }
    this.selezionaGiorno = this.selezionaGiorno.bind(this);
    this.getDays = this.getDays.bind(this);
    this.callGetDays = this.callGetDays.bind(this);
  }
  componentDidMount() {
    this.getDays();
    stopDigitalAssistant(); //Abbiamo superato il scegli luogo, non deve più apparire il DA
    trackPageView('data-appuntamento');

    utils.animate.fadeIn();
    utils.animate.slideIn(utils.getState().dati_locali.historyBack);
    utils.animate.zoomIn();
  }
  async callGetDays(lat, lng, days = 1) {
    const reduxState = utils.getState();
    let self = this;
    let payload = {
      Coordinate: {
        lat,
        lng,
      },
      Page: days,
      TipoFiliali: 0
    };

    if (reduxState.prodotto == 3) {
      payload = {
        ...payload,
        TipoFiliali: 1,
      };
    }

    apiInvoker.GiorniDisponibili(payload, res => self.addDays(res), err => {
      document.querySelector('.modal-error .error-text').innerText = err;
      document.querySelector('.modal-error-container').classList.add('is-modal-shown');
    });
  }
  async getDays() {
    const global_state = utils.getState();

    if (global_state && global_state.coordinate_luogo && global_state.coordinate_luogo.lat && global_state.coordinate_luogo.lng) {
      //Abbiamo tutti i dati che ci servono
      this.callGetDays(global_state.coordinate_luogo.lat, global_state.coordinate_luogo.lng, 1);
    } else if (global_state && global_state.indirizzo_filiale) {
      //Ci mancano le coordinate ma abbiamo l'indirizzo della filiale, li estrapoliamo da li
      let address = global_state.indirizzo_filiale;

      let geocoder = new window.mapkit.Geocoder({
        language: "it",
        getsUserLocation: false
      });

      if (address && address.toLowerCase().indexOf("ital") == -1) { //Se non c'è italy
        address = 'Italy, ' + address;
      }

      geocoder.lookup(address, function (err, data) {
        if (data && data.results && data.results.length > 0) {
          const miglior_risultato = data.results[0];
        }
      })
    }
  }

  selezionaGiorno(event) {
    //Setto il giorno selezionato
    const giorno = event.target.getAttribute("giorno");
    this.props.setGiorno(giorno);
    const gState = utils.getState();
    
    if (!gState || !gState.utente || !gState.utente.token) { //Se non hai il token
      this.props.setConsensi(null);
    }

    handleFlow();
  }

  showOtherDays = () => {
    const global_state = utils.getState();
    let payload = {
      Coordinate: {
        lat: global_state.coordinate_luogo.lat,
        lng: global_state.coordinate_luogo.lng,
      },
      Page: this.state.pagina_giorni + 1,
      TipoFiliali: 0
    };

    if (global_state.prodotto == 3) {
      payload = {
        ...payload,
        TipoFiliali: 1,
      };
    }

    apiInvoker.GiorniDisponibili(payload, (res) => this.addDays(res, false), err => {
      document.querySelector('.modal-error .error-text').innerText = err;
      document.querySelector('.modal-error-container').classList.add('is-modal-shown');
    });

  }
  addDays(res, firstActivation = true) {
    if (res.status == 200) {
      let giorni = res.data;
      let giorni_arr = this.state.giorni;
      //giorni = []; //ELIMINARE QUESTA RIGA
      if (giorni && giorni.length > 0) {
        giorni.forEach(function (g) {
          let oggi = moment().format('YYYY-MM-DD') == moment(g).format('YYYY-MM-DD');
          let label = oggi ? 'Oggi' : moment(g).locale('it').format("dddd DD MMMM");
          if (moment().add(1, 'days').format('YYYY-MM-DD') == moment(g).format('YYYY-MM-DD')) {
            label = 'Domani';
          }
          giorni_arr.push({
            'label': label,
            'value': moment(g).format('YYYY-MM-DD')
          });
        });
      } else {
        const showNextDataBtn = document.querySelector('#showNextDataBtn').style.display = 'none';
      }
      this.setState({
        'giorni': giorni_arr,
        'giorni_caricati': true,
        'pagina_giorni': this.state.pagina_giorni + 1
      });
      utils.animate.slideIn(utils.getState().dati_locali.historyBack, firstActivation);
      this.props.clearHistoryBack();
    }
  }

  render() {
    let cta = (<CTA />);
    let recapAreaVisibility = false;

    if (this.props.prodotto == 3) {
      recapAreaVisibility = true;
    }
    
    if ((this.state.giorni && this.state.giorni.length == 0) || this.props.prodotto == -2) {
      cta = (
        <h4 className="gsap-fade">
          La gran parte delle filiali/agenzie autorizzate Compass sono operative ma in considerazione dell’emergenza sanitaria in corso, ti suggeriamo di prendere un appuntamento telefonico e verrai contattato dalla filiale/agenzia autorizzata a te più vicina.
        </h4>
      )
    }

    return (
      <div>
        <Stepper percentage="50" />
        <ModalError />
        <Spinner visible={(!this.props.modificando && (!this.state.giorni || this.state.giorni.length == 0) && !this.props.filiali)} />
        <div className="grid-container">
          <RecapArea visible={ recapAreaVisibility } />
          <div className="grid-x grid-padding-x">
            <div className="cell animations-container">
              <h2 className="hasSubtitle gsap-fade">Quando vuoi fissare l'appuntamento?</h2>
              {cta}
              <div className={(!this.props.telefonico_forzato && ((this.state.giorni && this.state.giorni.length > 0) || this.props.prodotto != -2)) ? '' : 'hidden'}>
                {this.state.giorni.map((obj, index) => {
                  return <button key={index} className="customButton gsap-slide" giorno={obj.value} onClick={this.selezionaGiorno} >{utils.capitalizeFLetter(obj.label)}</button>
                })}
              </div>
              <div className={(this.props.telefonico_forzato || (this.props.prodotto !== 3 && this.state.giorni_caricati && this.state.giorni && this.state.giorni.length == 0) || this.props.prodotto == -2) ? '' : 'hidden'}>
                <button className="customButton" onClick={() => goToContactCenter(this.props.filiali)} >Appuntamento telefonico</button>
              </div>
              <button id="showNextDataBtn" className={"underlined gsap-fade " + (this.props.telefonico_forzato?'hidden':'')} onClick={() => this.showOtherDays()}>Mostra date successive</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DataAppuntamento);


// WEBPACK FOOTER //
// ./src/components/data_appuntamento/index.js